module.exports = __webpack_public_path__ + "static/media/Versus.e7dc6ef4.png";